import { RightContentSection } from 'applications/GSP/layouts/MainLayout/components/Header/components/components/RightContentSection';
import { RoleIndicator } from 'applications/GSP/layouts/MainLayout/components/Header/components/components/RoleIndicator';
import { Locale } from 'applications/GSP/layouts/MainLayout/components/Locale';
import { useUserRole } from 'applications/GSP/shared/hooks/user';
import { UserRole } from 'applications/GSP/shared/types';
import { Breadcrumbs } from 'features/Breadcrumbs';
import { LogoutButton } from 'features/LogoutButton';
import { Divider } from 'shared/components/Divider';

import { AppBarWrapper } from './components/AppBarWrapper';
import { ToolbarWrapper } from './components/ToolbarWrapper';

import type { FC } from 'react';

export const HEADER_DESKTOP_TEST_ID = 'header-desktop';

interface HeaderDesktopProps {
  onLogout(): void;
}

export const HeaderDesktop: FC<HeaderDesktopProps> = ({ onLogout }) => {
  const role = useUserRole();

  return (
    <AppBarWrapper position="static" data-testid={HEADER_DESKTOP_TEST_ID}>
      <ToolbarWrapper>
        <Breadcrumbs />
        <RightContentSection>
          {role !== UserRole.NonTeachingStaff && <Locale />}
          <RoleIndicator />
          <LogoutButton onClick={onLogout} />
        </RightContentSection>
      </ToolbarWrapper>
      <Divider sx={{ mt: 1 }} />
    </AppBarWrapper>
  );
};
